import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1899d617"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onKeydown"]

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'data-tag',
  props: {
    isSelected: { type: Boolean }
  },
  emits: ["on-tag-click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const getTagClass = computed(() => {
  return props.isSelected ? "tag-selected" : "tag-unselected";
});

function onTagClick() {
  emit("on-tag-click");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tag-container", getTagClass.value]),
    onClick: onTagClick,
    onKeydown: _withKeys(_withModifiers(onTagClick, ["stop"]), ["space"]),
    tabindex: "0",
    "data-test": "data-tag"
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 42, _hoisted_1))
}
}

})